// ─── Filtros ──────────────────────────────────────────────────────────────────

import { useGetApiV1ExamCorrectionDashboard } from '@/shared/api/generated';

export interface DashboardFilters {
  startDate?: string;
  endDate?: string;
  disciplineId?: number;
  page: number;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

/**
 * Hook para carregar o dashboard de correções com paginação e filtros.
 *
 * @param filters - Filtros de data, busca e paginação
 * @returns Dados do dashboard paginados
 *
 * @example
 * ```tsx
 * const { items, totalPages, isLoading } = useCorrectionDashboard({ page: 1 });
 * ```
 */
export function useCorrectionDashboard(filters: DashboardFilters) {
  const query = useGetApiV1ExamCorrectionDashboard({
    FilterStartDate: filters.startDate ?? '',
    FilterEndDate: filters.endDate ?? '',
    ...(filters.disciplineId !== undefined ? { FilterDisciplineId: filters.disciplineId } : {}),
    PageNumber: filters.page,
  });

  return {
    items: query.data?.data ?? [],
    currentPage: query.data?.currentPage ?? 1,
    totalPages: query.data?.totalPages ?? 1,
    totalCount: query.data?.totalCount ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
